import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "grid grid-cols-12 gap-3" }

import { MedKitSelect, MedKitNumberField, MedKitDateField } from '@bigpicturemedical/medkit'
import { DvCodedText, DvCount, DvDate, IPath, useWebTemplateHelpers, find, INode } from '@bigpicturemedical/openehr-vue'
import { PropType, onMounted, nextTick } from 'vue'
import { BlockHeader, BlockPanel } from './_layout'


export default /*#__PURE__*/_defineComponent({
  __name: 'TobaccoSmokingSummaryBlock',
  props: {
  path: {
    type: Object as PropType<IPath>,
    required: true
  },
  name: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: true
  },
  errors: {
    type: Array as PropType<Array<string>>,
    default: () => []
  }
},
  setup(__props) {

const props = __props;



const { getData, template, updateData } = useWebTemplateHelpers()

onMounted(() => {
  nextTick(() => {
    if (getData(props.path.add('pack_definition'))) {
      return
    }

    setDefaultPackDefinition()
  })
})

const setDefaultPackDefinition = () => {
  const node = find(template.value, props.path.add('pack_definition')) as INode
  const defaultValue = node.inputs.find((input) => input.type === 'INTEGER').defaultValue
  updateData(props.path.add('pack_definition'), defaultValue)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BlockHeader), null, {
      heading: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.name), 1)
      ]),
      description: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.description), 1)
      ]),
      _: 1
    }),
    _createVNode(_unref(BlockPanel), { class: "p-6 space-y-6" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(DvCodedText), {
            path: props.path.add('status')
          }, {
            default: _withCtx(({ name, options, selected, setSelected, errors, validate, required }) => [
              _createVNode(_unref(MedKitSelect), {
                class: _normalizeClass({
              'col-span-6': _unref(getData)(props.path.add('status'))?.['|code'] !== '8517006',
              'col-span-4': _unref(getData)(props.path.add('status'))?.['|code'] === '8517006'
            }),
                error: errors[0],
                label: name,
                "model-value": selected,
                options: options,
                required: required,
                "onUpdate:modelValue": setSelected,
                onInput: validate
              }, null, 8, ["class", "error", "label", "model-value", "options", "required", "onUpdate:modelValue", "onInput"])
            ]),
            _: 1
          }, 8, ["path"]),
          _createVNode(_unref(DvDate), {
            "present-if": ['77176002', '8517006'].includes(_unref(getData)(props.path.add('status'))?.['|code']),
            path: props.path.add('start_date')
          }, {
            default: _withCtx(({ name, value, setValue, errors, validate, validateIfAlreadyValidated, required }) => [
              _createVNode(_unref(MedKitDateField), {
                error: errors[0],
                label: name,
                "model-value": value,
                class: _normalizeClass({
              'col-span-6': _unref(getData)(props.path.add('status'))?.['|code'] === '77176002',
              'col-span-4': _unref(getData)(props.path.add('status'))?.['|code'] === '8517006'
            }),
                required: required,
                "onUpdate:modelValue": setValue,
                onInput: validateIfAlreadyValidated,
                onBlur: validate
              }, null, 8, ["error", "label", "model-value", "class", "required", "onUpdate:modelValue", "onInput", "onBlur"])
            ]),
            _: 1
          }, 8, ["present-if", "path"]),
          _createVNode(_unref(DvDate), {
            "present-if": _unref(getData)(props.path.add('status'))?.['|code'] === '8517006',
            path: props.path.add('quit_date')
          }, {
            default: _withCtx(({ name, value, setValue, errors, validate, validateIfAlreadyValidated, required }) => [
              _createVNode(_unref(MedKitDateField), {
                class: "col-span-4",
                error: errors[0],
                label: name,
                "model-value": value,
                required: required,
                "onUpdate:modelValue": setValue,
                onInput: validateIfAlreadyValidated,
                onBlur: validate
              }, null, 8, ["error", "label", "model-value", "required", "onUpdate:modelValue", "onInput", "onBlur"])
            ]),
            _: 1
          }, 8, ["present-if", "path"]),
          _createVNode(_unref(DvCount), {
            "present-if": ['77176002', '8517006'].includes(_unref(getData)(props.path.add('status'))?.['|code']),
            path: props.path.add('overall_use')
          }, {
            default: _withCtx(({ name, value, setValue, errors, validate, required }) => [
              _createVNode(_unref(MedKitNumberField), {
                placeholder: "No. of pack years",
                class: "col-span-12",
                unit: "pack years",
                "help-text": "1 pack year = 20 cigarettes daily for 1 year",
                error: errors[0],
                label: name,
                "model-value": value,
                required: required,
                "onUpdate:modelValue": setValue,
                onInput: validate
              }, null, 8, ["error", "label", "model-value", "required", "onUpdate:modelValue", "onInput"])
            ]),
            _: 1
          }, 8, ["present-if", "path"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})